'use strict';

// Checks if the title contains only Latin characters
module.exports.isValidTitle = function(text) {
  let pattern = /[Ѐ-ӾԀ-\u052e\u0600-۾ݐ-ݾ\u08a0-\u08fe\u2de0-\u2dfe⺀-\u2efe\u3000-〾㇀-\u31ee㈀-㋾㌀-㏾㐀-\u4dbe一-\u9ffeꙀ-\ua69e豈-\ufafeﭐ-\ufdfe︰-﹎ﹰ-\ufefe]|[\ud840-\ud868\ud86a-\ud86c][\udc00-\udfff]|\ud83b[\ude00-\udefe]|\ud869[\udc00-\udede\udf00-\udfff]|\ud86d[\udc00-\udf3e\udf40-\udfff]|\ud86e[\udc00-\udc1e]|\ud87e[\udc00-\ude1e]/;
  return pattern.test(text);
};
